import usePolledQuery from "apollo/usePolledQuery";
import { PollingIntervalGroups } from "apollo/constants";

import { TEMPLATE_DEPLOYMENT_QUERY } from "./gql";

type UseDeploymentParams = {
  templateId: string;
  deploymentId: string;
};

const useTemplateDeployment = ({ templateId, deploymentId }: UseDeploymentParams) => {
  const { data, loading, error } = usePolledQuery(TEMPLATE_DEPLOYMENT_QUERY, {
    pollingGroup: PollingIntervalGroups.Lists,
    variables: {
      templateID: templateId,
      id: deploymentId,
    },
    skip: !templateId || !deploymentId,
  });

  return {
    deployment: data?.templateDeployment,
    loading,
    error,
  };
};

export default useTemplateDeployment;
